import { API_BASE_URL } from "./config";
import { authHeadersForGet, authHeadersJson } from "./http";
import { AttributeSet, AttributeSetItem } from "../types/attribute-set";

export const attributeSetsApi = {
  getAll: async (): Promise<AttributeSet[]> => {
    const response = await fetch(`${API_BASE_URL}/attribute-sets`, {
      headers: authHeadersForGet(),
    });
    return response.json();
  },

  getOne: async (reference: string): Promise<AttributeSet> => {
    const response = await fetch(
      `${API_BASE_URL}/attribute-sets/${reference}`,
      { headers: authHeadersForGet() }
    );
    return response.json();
  },

  create: async (set: { name: string }): Promise<AttributeSet> => {
    const response = await fetch(
      `${API_BASE_URL}/attribute-sets`,
      {
        method: "POST",
        headers: authHeadersJson(),
        body: JSON.stringify(set),
      }
    );
    return response.json();
  },

  update: async (
    reference: string,
    set: Partial<{ name: string }>
  ): Promise<AttributeSet> => {
    const response = await fetch(
      `${API_BASE_URL}/attribute-sets/${reference}`,
      {
        method: "PUT",
        headers: authHeadersJson(),
        body: JSON.stringify(set),
      }
    );
    return response.json();
  },

  delete: async (reference: string): Promise<boolean> => {
    const response = await fetch(
      `${API_BASE_URL}/attribute-sets/${reference}`,
      {
        method: "DELETE",
        headers: authHeadersForGet(),
      }
    );
    return response.ok;
  },

  addItem: async (reference: string, item: AttributeSetItem): Promise<AttributeSetItem> => {
    const response = await fetch(
      `${API_BASE_URL}/attribute-sets/${reference}/items`,
      {
        method: "POST",
        headers: authHeadersJson(),
        body: JSON.stringify(item),
      }
    );
    return response.json();
  },

  updateItem: async (
    reference: string,
    itemId: number,
    item: Partial<AttributeSetItem>
  ): Promise<AttributeSetItem> => {
    const response = await fetch(
      `${API_BASE_URL}/attribute-sets/${reference}/items/${itemId}`,
      {
        method: "PUT",
        headers: authHeadersJson(),
        body: JSON.stringify(item),
      }
    );
    return response.json();
  },

  removeItem: async (reference: string, itemId: number): Promise<boolean> => {
    const response = await fetch(
      `${API_BASE_URL}/attribute-sets/${reference}/items/${itemId}`,
      {
        method: "DELETE",
        headers: authHeadersForGet(),
      }
    );
    return response.ok;
  },

  removeItemByAttributeRef: async (setReference: string, attributeReference: string): Promise<boolean> => {
    const response = await fetch(
      `${API_BASE_URL}/attribute-sets/${setReference}/items/by-attribute/${attributeReference}`,
      {
        method: "DELETE",
        headers: authHeadersForGet(),
      }
    );
    return response.ok;
  },
};
